<app-help-page mainVideo="matching-for-advertising-sources"
               [tutorials]="['matching-automatic', 'matching-organic-sources']"
               [videos]="['matching-for-advertising-sources', 'organic-sources', 'matching-with-attribution']"></app-help-page>
